import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PublicHomeNav } from "../../Common/PublicComponents/PublicHomeNav";
import { PublicSkipContentLink } from "../../Common/PublicComponents/PublicSkipContentLink";
import { PUBLIC_SITE_URL_ACTIVE_MAP } from "../../../App";
import { utils } from "../../../helpers/utils";
import { User } from "../../../Types/User";
import { userRole } from "../../../Constants/userRoles";
import { SectionData } from "../ManageHomepageSections/SectionCard";
import { getPublicHomepageSections } from "../../../Services/AdminServices";

export function PublicHome() {
  const [isCounselor, setIscounselor] = useState<boolean>(
    utils.isCounselor() as boolean
  );

  const [isEmploymentCoordinator, setIsEmploymentCoordinator] =
    useState<boolean>(utils.isEmploymentCoordinator() as boolean);

  const [sectionData, setSectionData] = useState<SectionData[]>([]);

  useEffect(() => {
    getPublicHomepageSections(false).then((response) => {
      if (response && response.data) {
        let data = (response.data as any).sections as SectionData[];
        setSectionData(data);
      } else {
        throw new Error("Unable to load sections data from server.");
      }
    });
  }, []);
  return (
    <div>
      <div className="wrapper">
        <PublicSkipContentLink />
        <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
        <div className="hero" style={{ maxWidth: "1280px", margin: "auto" }}>
          <div className="hero__image public-site">
            <img
              src="assets/images/temp/hero.jpg"
              alt="Career exploration image"
              aria-hidden="true"
            />
          </div>

          <div className="hero__content">
            <div className="shell">
              <div className="hero__content-inner public-site">
                <div className="hero__inner public-site">
                  <h1>Virtual Resource Room</h1>
                  <p>
                    Your resource for career exploration and education support,
                    local degree and certificate programs, and finding a great
                    job!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main" id="content">
          <section className="section section-cards">
            <div className="shell">
              <div className="section__head public-site">
                <h2>Explore * Prepare * Achieve!</h2>
              </div>

              <div className="section__body">
                <div className="section__content">
                  <div className="section__content-inner homev2">
                    <ul className="cards">
                      {sectionData.map((section, index) => {
                        return (
                          <li
                            className="card card--success"
                            key={section.homepageSectionId}
                          >
                            <div
                              className="card__inner"
                              style={{
                                backgroundColor: section.backgroundColor,
                              }}
                            >
                              <div className="card__inner-content">
                                <div className="card__icon">
                                  <div className="ico-explore">
                                    <img
                                      src={`assets/images/svg/${section.iconName}`}
                                      alt="section icon"
                                      aria-hidden="true"
                                    ></img>
                                  </div>
                                </div>

                                <div className="card__content">
                                  {section.isHtmlContent === true && (
                                    <h3>
                                      <Link
                                        to={`/pages/${section.url}`}
                                        className="public-site"
                                      >
                                        {section.title || ""}
                                      </Link>
                                    </h3>
                                  )}
                                  {section.isHtmlContent === false && (
                                    <h3>
                                      <Link
                                        to={`/${section.url}`}
                                        className="public-site"
                                      >
                                        {section.title || ""}
                                      </Link>
                                    </h3>
                                  )}

                                  <p>{section.teaserText || ""}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {(isCounselor || isEmploymentCoordinator) && (
            <section className="section section-tiles section-solid">
              <div className="shell">
                <header className="section__head">
                  <h2>RSA VR Specialist Portal</h2>

                  <p>
                    Arrange job seeker meetings with RSA Employment Coordinators,
                    register job seekers for RSA Workshops and Employer
                    Spotlight Presentations, and view employment opportunities
                    offered by RSA employer partners and information on job
                    fairs and other hiring events.
                  </p>
                </header>

                <div className="section__body">
                  <div className="tiles">
                    <div className="cols public-home-portal">
                      {(isCounselor || isEmploymentCoordinator) && (
                        <div className="tile public-home-tile">
                          <div className="tile__inner">
                            <div className="tile__inner-content">
                              <div className="tile__badge">
                                <div className="ico-lock">
                                  <img
                                    src="assets/images/svg/ico-lock.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__icon">
                                <div className="ico-user-speaker">
                                  <img
                                    src="assets/images/employmentSpecialist.PNG"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__content">
                                <h3>
                                  <Link
                                    to="/requestRSASpecialistMeeting"
                                    className="public-site"
                                  >
                                    Arrange Job Seeker Meetings with an RSA
                                    Employment Coordinator
                                  </Link>
                                </h3>

                                <p>
                                  Job seekers receive assistance with their
                                  resumes, interview preparation and mock
                                  interviews, researching employers, accessing
                                  local training and education opportunities,
                                  and searching and applying for jobs
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {(isCounselor || isEmploymentCoordinator) && (
                        <div className="tile  public-home-tile">
                          <div className="tile__inner">
                            <div className="tile__inner-content">
                              <div className="tile__badge">
                                <div className="ico-lock">
                                  <img
                                    src="assets/images/svg/ico-lock.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__icon">
                                <div className="ico-tasks">
                                  <img
                                    src="assets/images/jobseekerWorkshops.PNG"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__content">
                                <h3>
                                  <Link
                                    to="/JobSeekerWorkshops"
                                    className="public-site"
                                  >
                                    Register Job Seekers for RSA Workshops
                                  </Link>
                                </h3>

                                <p>
                                  RSA Workshops are a great opportunity for job
                                  seekers to build and improve their resumes and
                                  cover letters and sharpen their interviewing
                                  skills and work-related soft skills
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {isCounselor && (
                        <div className="tile public-home-tile">
                          <div className="tile__inner">
                            <div className="tile__inner-content">
                              <div className="tile__badge">
                                <div className="ico-lock">
                                  <img
                                    src="assets/images/svg/ico-lock.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="tile__icon">
                                <div className="ico-video-gallery">
                                  <img
                                    src="assets/images/spotlight.PNG"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="tile__content">
                                <h3>
                                  <Link
                                    to="/employerSpotlightPresentation"
                                    className="public-site"
                                  >
                                    RSA Employer Spotlight Presentations
                                  </Link>
                                </h3>
                                <p>
                                  Learn about high-demand industries and
                                  occupations and opportunities offered by RSA
                                  employer partners and training providers and
                                  register job seekers for these highly
                                  informative presentations
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {isCounselor && (
                        <div className="tile public-home-tile">
                          <div className="tile__inner">
                            <div className="tile__inner-content">
                              <div className="tile__badge">
                                <div className="ico-lock">
                                  <img
                                    src="assets/images/svg/ico-lock.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__icon">
                                <div className="ico-briefcase">
                                  <img
                                    src="assets/images/employmentOpportunities.PNG"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__content">
                                <h3>
                                  <Link
                                    to="/employmentOpportunities"
                                    className="public-site"
                                  >
                                    Employment Opportunities{" "}
                                  </Link>
                                </h3>

                                <p>
                                  Learn about employment opportunities offered
                                  by RSA employer partners and receive
                                  information on job fairs and other hiring
                                  events!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {isCounselor && (
                        <div className="tile public-home-tile">
                          <div className="tile__inner">
                            <div className="tile__inner-content">
                              <div className="tile__badge">
                                <div className="ico-lock">
                                  <img
                                    src="assets/images/svg/ico-lock.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__icon">
                                <div className="ico-briefcase">
                                  <img
                                    src="assets/images/casasTesting.png"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="tile__content">
                                <h3>
                                  <Link
                                    to="/registerCASASTesting/0"
                                    className="public-site"
                                  >
                                    CASAS Testing{" "}
                                  </Link>
                                </h3>

                                <p>
                                  Learn about employment opportunities offered
                                  by RSA employer partners and receive
                                  information on job fairs and other hiring
                                  events!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
